import React from "react";
import MascotLoadingOverlay from "../../../shared/MascotLoadingOverlay";

/**
 * V2 Settings yukleme skeleton — kategori sekmeleri + arama + field grid'i
 * iskelet halinde gosterir.
 */
export default function SettingsSkeleton({ message = "Cihaz ayarları yükleniyor..." }) {
  return (
    <div className="relative space-y-3 pb-24">
      <MascotLoadingOverlay message={message} />

      <div className="opacity-40 pointer-events-none space-y-3">
        {/* PageHeader skeleton */}
        <div className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gray-200 animate-pulse" />
            <div className="flex-1 space-y-1.5">
              <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
              <div className="h-3 w-48 bg-gray-200 rounded animate-pulse" />
            </div>
            <div className="flex gap-2">
              <div className="h-9 w-20 bg-gray-200 rounded-lg animate-pulse" />
              <div className="h-9 w-20 bg-gray-200 rounded-lg animate-pulse" />
              <div className="h-9 w-24 bg-gray-200 rounded-lg animate-pulse" />
            </div>
          </div>
        </div>

        {/* FilterTabs skeleton */}
        <div className="flex gap-2 overflow-hidden">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-10 w-28 bg-gray-200 rounded-xl animate-pulse shrink-0"
            />
          ))}
        </div>

        {/* SearchInput skeleton */}
        <div className="h-10 max-w-md bg-gray-200 rounded-xl animate-pulse" />

        {/* Field grid skeleton */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 mt-4">
          {Array.from({ length: 9 }).map((_, i) => (
            <div
              key={i}
              className="rounded-xl border border-gray-200 bg-white p-3 space-y-2 animate-pulse"
            >
              <div className="flex items-center justify-between">
                <div className="h-3 w-20 bg-gray-200 rounded" />
                <div className="h-3 w-8 bg-gray-200 rounded" />
              </div>
              <div className="h-9 w-full bg-gray-100 rounded-lg" />
              <div className="h-2 w-16 bg-gray-100 rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
